/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Tooltip, FormFeedback } from "reactstrap";

const SwitchInput = ({
  label = "Toggle Option", // Default label
  id = "switchInput",
  name = "switch",
  required = false,
  defaultState = false, // Default state is off
  onText = "On", // Customizable on text
  offText = "Off", // Customizable off text
  onChange = () => { }, // Placeholder for change handler
  showHelp = false,
  helpText = "Toggle the switch.",
  requiredErrorMessage = "This field is required.",
  customErrorMessages = {}, // For developers to pass custom error messages
  layout = "below", // "below" or "inline" with label
  size = "medium", // Customizable size: "small", "medium", "large" or custom pixel value
  fontSize = "16px", // Customizable font size
  labelColor = "black", // Customizable label color
  switchColor = "#2196F3", // Default switch color when ON
  switchOffColor = "#ccc", // Default switch color when OFF
  visible = true, // New prop to control visibility
}) => {
  const [isChecked, setIsChecked] = useState(defaultState); // Default to off unless otherwise specified
  const [error, setError] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const validateSwitch = () => {
    if (required && !isChecked) {
      setError(customErrorMessages.required || requiredErrorMessage);
      return false;
    }
    setError("");
    return true;
  };

  const handleSwitchChange = (e) => {
    const checked = e.target.checked;
    setIsChecked(checked);
    validateSwitch();
    onChange(checked);
  };

  // Return null if the switch is not visible
  if (!visible) {
    return null;
  }

  // Size settings
  let switchWidth, switchHeight, switchCircleSize;

  switch (size) {
    case "small":
      switchWidth = "40px";
      switchHeight = "24px";
      switchCircleSize = "20px";
      break;
    case "medium":
      switchWidth = "42px";
      switchHeight = "22px";
      switchCircleSize = "17px";
      break;
    case "large":
      switchWidth = "80px";
      switchHeight = "44px";
      switchCircleSize = "34px";
      break;
    default: // Treat other cases as pixel values
      switchWidth = size; // Assume size is provided in px, e.g., "70px"
      switchHeight = parseInt(size) * 0.6 + "px"; // Adjust height proportionally
      switchCircleSize = (parseInt(size) * 0.5) + "px"; // Circle size based on width
  }

  return (
    <div className={layout === "inline" ? "d-flex align-items-center" : ""}>
      {label && (
        <label
          htmlFor={id}
          style={{
            width: layout === "inline" ? "20%" : "100%",
            color: labelColor,
            fontSize: fontSize,
          }}
          className="d-flex"
        >
          {label} {required && <span className="text-danger">*</span>}
          {showHelp && (
            <span id="helpTooltip" className="px-2">
              <i className="ri-question-line" style={{ cursor: "pointer", fontSize: "16px" }}></i>
            </span>
          )}
        </label>
      )}

      {showHelp && (
        <Tooltip
          placement="right"
          isOpen={tooltipOpen}
          target="helpTooltip"
          toggle={() => setTooltipOpen(!tooltipOpen)}
        >
          {helpText}
        </Tooltip>
      )}

      <div className="w-100" style={{ display: "flex", alignItems: "center" }}>
        <label style={{ position: "relative", display: "inline-block", width: switchWidth, height: switchHeight }}>
          <input
            type="checkbox"
            id={id}
            name={name}
            checked={isChecked}
            onChange={handleSwitchChange}
            style={{ display: "none" }}
          />
          <span
            style={{
              position: "absolute",
              cursor: "pointer",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: isChecked ? switchColor : switchOffColor,
              transition: ".4s",
              borderRadius: "34px",
            }}
          />
          <span
            style={{
              position: "absolute",
              height: switchCircleSize,
              width: switchCircleSize,
              left: isChecked ? "21px" : "4px",
              bottom: "3px",
              backgroundColor: "#fff",
              transition: ".4s",
              borderRadius: "50%",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
            }}
          />
        </label>
        <span className="ml-3" style={{ fontSize: fontSize, marginLeft: "10px" }}>
          {isChecked ? onText : offText}
        </span>
      </div>

      {error && <FormFeedback type="invalid">{error}</FormFeedback>}
    </div>
  );
};

export default SwitchInput;
